export const Math_floor = (i, j) => Math.floor(i / j) * j
